import { useState } from 'react';

import { useAuth } from 'context/auth';
import { useDeleteInstance } from 'hooks/organizations';
import ConfirmModal from 'components/modals/ConfirmModal';
import { CustomIconButton } from 'components/buttons';

function DeleteInstanceButton({ instanceId }) {

  const { selectedOrgId } = useAuth();
  const mutateDelete = useDeleteInstance(selectedOrgId);

  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleDelete = () => {
    mutateDelete.mutate(instanceId);
  };

  return (
    <>
      <CustomIconButton onClick={() => setConfirmOpen(true)} type="delete" />
      <ConfirmModal
        open={confirmOpen}
        setOpen={setConfirmOpen}
        title="Confirm Delete Instance"
        text="Are you sure you want to delete this instance? Any check configurations using this will be synced without the instance in the future."
        okText="Yes, Delete"
        cancelText="Cancel"
        onConfirm={() => handleDelete()}
      />
    </>
  );
}

export default DeleteInstanceButton;